import { Shield, Users, LineChart, Target } from "lucide-react";

const AboutSection = () => {
  return (
    <section className="py-16 sm:py-24 px-4 sm:px-6 lg:px-8 bg-background">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center mb-4">
          <span className="text-foreground">Gerindo Fortunas, </span>
          <span className="bg-gradient-primary bg-clip-text text-transparent">Multiplicando Legados</span>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
          <div className="flex gap-4 p-6 rounded-xl bg-card border border-border shadow-card">
            <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-full shrink-0">
              <Shield className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h3 className="font-semibold text-foreground mb-1">Segurança Patrimonial</h3>
              <p className="text-sm text-muted-foreground">Gestão de risco rigorosa para proteger e valorizar o seu capital a longo prazo.</p>
            </div>
          </div>

          <div className="flex gap-4 p-6 rounded-xl bg-card border border-border shadow-card">
            <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-full shrink-0">
              <LineChart className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h3 className="font-semibold text-foreground mb-1">Estratégias Profissionais</h3>
              <p className="text-sm text-muted-foreground">Operações baseadas em análise técnica avançada com profissionais experientes no mercado.</p>
            </div>
          </div>

          <div className="flex gap-4 p-6 rounded-xl bg-card border border-border shadow-card">
            <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-full shrink-0">
              <Users className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h3 className="font-semibold text-foreground mb-1">Atendimento Personalizado</h3>
              <p className="text-sm text-muted-foreground">Suporte dedicado e acompanhamento próximo para cada cliente da nossa carteira.</p>
            </div>
          </div>

          <div className="flex gap-4 p-6 rounded-xl bg-card border border-border shadow-card">
            <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-full shrink-0">
              <Target className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h3 className="font-semibold text-foreground mb-1">Resultados Consistentes</h3>
              <p className="text-sm text-muted-foreground">Foco em rentabilidade sustentável com transparência total nos relatórios de performance.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
